var React = require('react');

function MenuInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M120-240v-66.67h720V-240H120Zm0-206.67v-66.66h720v66.66H120Zm0-206.66V-720h720v66.67H120Z"}));
}

MenuInline.defaultProps = {"height":"40px","viewBox":"0 -960 960 960","width":"40px","fill":"#2b2b2b"};

module.exports = MenuInline;

MenuInline.default = MenuInline;
